const { accountNo } = require('./account-no')
const { censorName } = require('./censor-name')
const { currency } = require('./currency')
const { integer } = require('./integer')
const { float } = require('./float')
const { lowercase } = require('./lowercase')
const { lowercaseFirstLetter } = require('./lowercase-first-letter')
const { number } = require('./number')
const { phone } = require('./phone')
const { roundDown } = require('./round-down')
const { roundUp } = require('./round-up')
const { uppercase } = require('./uppercase')
const { uppercaseFirstLetter } = require('./uppercase-first-letter')
const { rate } = require('./rate')
const { splitByThousand } = require('./split-by-thousand')

module.exports = {
  accountNo,
  censorName,
  currency,
  integer,
  float,
  lowercase,
  lowercaseFirstLetter,
  number,
  phone,
  rate,
  roundDown,
  roundUp,
  uppercase,
  uppercaseFirstLetter,
  splitByThousand
}
